/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useDispatch } from "react-redux";
import actions from "../redux/actions/userAction";
import Skeleton from "react-loading-skeleton";

/* ICONS */
import { IoIosBed } from "react-icons/io";
import { FaBath } from "react-icons/fa";

/* IMAGE */
import Placeholder from "../assets/featured-home-placeholder.jpg";

/* APIS */
import { getMLS } from "../service/api";

/* Number of listings to request for the carousel. */
const FEATURED_LIMIT = 8;

/* PRICE FORMATTER */
const priceFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const PropertyBoxLoader = () => {
  return (
    <div className="property-box">
      <img
        src={Placeholder}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = Placeholder;
        }}
        alt="Property Box"
      />
      <div className="bg-overlay">
        <div className="info-box">
          <div>
            <Skeleton className="street-loading" />
            <Skeleton className="city-loading" />
          </div>
        </div>
      </div>
    </div>
  );
};

const PropertyBox = (props) => {
  /* The MLS has no thumbnail variant, so each photo is a ~200KB original.
     Render only the primary photo (Order 1) rather than one <img> per photo. */
  const primaryPhoto =
    props?.propertyImg?.find(
      (img) =>
        img?.MediaURL?.includes("PHOTO") &&
        img?.MediaURL?.includes(`/${props?.mlsNumber}/1/`),
    ) || props?.propertyImg?.[0];

  /* Slides past the first screenful are offscreen in the carousel, so let the
     browser defer them instead of racing all of them on load. */
  const isAboveFold = props?.index < 4;

  return (
    <Link
      to={`/property-detail/${props?.mlsNumber}/${props?.mlsKey}`}
      style={{ textDecoration: "none", color: "#000" }}
    >
      <div className="property-box">
        <img
          src={primaryPhoto?.MediaURL || Placeholder}
          decoding="async"
          loading={isAboveFold ? "eager" : "lazy"}
          fetchpriority={props?.index === 0 ? "high" : "auto"}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = Placeholder;
          }}
          alt={props.streetName}
        />
        <div className="bg-overlay">
          <div className="info-box">
            <div className="info-text">
              {props.price ? (
                <p className="price">{priceFormatter.format(props.price)}</p>
              ) : null}
              <h5>{props.streetName}</h5>
              <p>{props.cityName}</p>
            </div>
            <div className="specs">
              <div className="spec">
                <IoIosBed className="icon" color="#3F3936" size="18" />
                <span>{props.beds ? props.beds : 0}</span>
              </div>
              <div className="spec">
                <FaBath className="icon" color="#3F3936" size="15" />
                <span>{props.baths ? props.baths : 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

const FeaturedListings = () => {
  const [page, setPage] = useState(1);
  const [MLSLoading, setMLSLoading] = useState(false);
  const [data, setData] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();

  /* DEFAULT FILTERS */
  let defaultFilters = {
    page: page,
    isFilter: true,
    /* Ask the MLS for card fields + the primary photo only, capped to the
       number of slides we actually show. Without these the API returns every
       field and every photo of a full default page. */
    lite: true,
    top: FEATURED_LIMIT,
    propertyStatus: ["Active"],
    minBedroom: null,
    maxBedroom: null,
    minPrice: 1,
    maxPrice: null,
    minBath: null,
    maxBath: null,
    location: null,
    featured: true,
    propertySubType: [],
    propertyType: [],
    minYearBuilt: null,
    maxYearBuilt: null,
    minDaysOnMarket: null,
    maxDaysOnMarket: null,
    minLotSize: null,
    maxLotSize: null,
    minLotSizeAcres: null,
    maxLotSizeAcres: null,
    minLatitude: null,
    maxLatitude: null,
    minLongitude: null,
    maxLongitude: null,
    sortBy: null,
  };

  const [params, setParams] = useState(defaultFilters);

  /* GET MLS DATA */
  const getMLSData = () => {
    setMLSLoading(true);

    let datas = params;
    let obj = datas;
    obj.page = page;
    obj.featured = true;

    getMLS(obj)
      .then((res) => {
        if (res.status) {
          let list = [];
          let length = 0;
          res?.data?.map((obj) => {
            if (obj?.value?.length > 0) {
              list = list.concat(obj?.value);
              length += obj["@odata.count"];
            }
          });
          setData(list.reverse());
          if (length > 0) {
            list?.forEach((element) => {
              setMarkers((current) => [
                ...current,
                {
                  lat: element?.Latitude,
                  lng: element?.Longitude,
                  data: element,
                  time: new Date(),
                },
              ]);
            });
          }
          setTotal(length);
          setTotalPages(length / 20);
          dispatch(actions.setMLS(res?.data[1]?.value));
        }
      })
      .finally((res) => {
        setMLSLoading(false);
      });
  };

  /* USEEFFECT */
  useEffect(() => {
    getMLSData();
  }, [page]);

  return (
    <section className="featured-listings">
      <div className="container">
        <div className="heading">
          <h2>FEATURED LISTINGS</h2>
          <Link to="/featured-listings" className="listings-link">
            View all listings
          </Link>
        </div>
        <div className="row mt-4">
          <Swiper
            spaceBetween={30}
            navigation={true}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              400: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1000: {
                slidesPerView: 4,
              },
            }}
            autoplay
            modules={[Autoplay, Navigation]}
          >
            {MLSLoading ? (
              <>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-xl-12 col-sm-12">
                    <PropertyBoxLoader />
                  </div>
                </SwiperSlide>
              </>
            ) : (
              false
            )}
            {total > 0 &&
              data?.map((property, index) => {
                return (
                  <SwiperSlide key={property?.ListingKey}>
                    <div className="col-xl-12 col-sm-12">
                      <PropertyBox
                        index={index}
                        propertyImg={property?.Media}
                        streetName={property.UnparsedAddress}
                        cityName={property.City}
                        price={property.ListPrice}
                        beds={property.BedroomsTotal}
                        baths={property.BathroomsTotalInteger}
                        mlsNumber={property.ListingKey}
                        mlsKey={property.OriginatingSystemName}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturedListings;
